import { useEffect, useState } from 'react';

export const useScale = (ref: React.RefObject<Element>, width: number, height: number) => {
    const [scale, setScale] = useState<number>(1);

    useEffect(() => {
        const refreshData = () => {
            const wrapper = ref.current;
            if (wrapper) {
                const availableWidth = wrapper.clientWidth;
                const availableHeight = wrapper.clientHeight;

                const smax = Math.max(availableWidth / width, availableHeight / height);
                const smin = Math.min(availableWidth / width, availableHeight / height);

                const s = smax > 1 ? smin : smax;
                setScale(s);
            }
        };
        refreshData();
        window.addEventListener('resize', refreshData);

        return () => {
            window.removeEventListener('resize', refreshData);
        };
    }, [ref, height, width]);

    return scale;
};
